import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type { ExportApiResponse, ExportCreationRequest } from '@cdw-ae/common-data';
import { API_URL_BUILDER, ApiUrlBuilder } from '@cdw-ae/routes-shared-api';
import type { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExportService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_URL_BUILDER) private readonly urlBuilder: ApiUrlBuilder
  ) {}

  /**
   * Initiate an export. When `gridSessionId` is provided, attach it as
   * the `x-cdw-grid-session` header so the saas-device-api's `/exports`
   * controller can resolve the user's Redis selection set
   * (`request.useSelection: true` triggers materialization).
   */
  initiateExport(
    request: ExportCreationRequest,
    gridSessionId?: string
  ): Observable<ExportApiResponse> {
    const options = gridSessionId
      ? {
          headers: new HttpHeaders({ 'x-cdw-grid-session': gridSessionId }),
        }
      : {};
    return this.http.post<ExportApiResponse>(
      this.urlBuilder.backendApi('exports', ''),
      request,
      options
    );
  }
}
